import Vue from 'vue'
import router from '@/router'
import { getWeChatSignature } from '@/api/user'
import { initWXConfig, shareWeChat } from '@/libs/wechat-share'
import { AppType } from '@/utils'
import { enableShare, disableShare, setTitle } from '@/libs/ds-bridge'

function callback(url) {
  const timestamp = parseInt((new Date().getTime()) / 1000)
  const str = 'qwertyuiopasdfghjklzxcvbnm1234567890'
  const s = str.split('')
  let randStr = ''
  for (let i = 0; i < 7; i++) {
    randStr += s[getRandomNum(1, 36)]// 生成7位的随机签名字符串
  }
  return getWeChatSignature({
    url: url,
    noncestr: randStr,
    timestamp: timestamp
  })
}

/**
 * 通过当前url去请求获取签名需要的信息
 * @param url:当前的url
 * @param cb:回调函数(用于通过当前url去请求获取签名需要的信息)
 * @returns {Promise}
 */
function reqSignByUrl(url, cb) {
  const mUrl = url.split('#')[0] || window.location.href.split('#')[0]
  return new Promise((resolve, reject) => {
    resolve(cb(mUrl))
  })
}

function getRandomNum(lbound, ubound) {
  return (Math.floor(Math.random() * (ubound - lbound)) + lbound)
}

// router.afterEach((to, from) => {
//   reqSignByUrl('', callback).then((response) => {
//     console.log(response)
//     const data = response.data
//     initWXConfig({
//       appId: data.appId,
//       timestamp: data.timestamp,
//       nonceStr: data.nonceStr,
//       signature: data.signature
//     }, true)
//   })
// })

function doActionAfterWeixinJSBridgeReady(onBridgeReady) {
  if (typeof WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    onBridgeReady()
  }
}

function hideMenuShare() {
  doActionAfterWeixinJSBridgeReady(function () {
    /* eslint-disable no-undef */
    if (typeof WeixinJSBridge !== 'undefined' && typeof WeixinJSBridge.call === 'function') {
      // 通过下面这个API隐藏右上角按钮
      WeixinJSBridge.call('hideOptionMenu')
    }
  })
}

function showMenuShare() {
  doActionAfterWeixinJSBridgeReady(function () {
    if (typeof WeixinJSBridge !== 'undefined' && typeof WeixinJSBridge.call === 'function') {
      WeixinJSBridge.call('showOptionMenu')
    }
  })
}

router.beforeEach((to, from, next) => {
  hideMenuShare()
  disableShare()
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
    setTitle(to.meta.title)
  }
  // window.scroll(0, 0)
  next()
})

Vue.prototype.wxShare = function(shareParams) {
  if (AppType.isInWeChat()) {
    showMenuShare()
    reqSignByUrl('', callback).then((response) => {
      const data = response.data
      initWXConfig({
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature
      }, false)
      shareWeChat(shareParams)
    })
  } else if (AppType.isInApp()) {
    let miniPath = '/pages/webview/main?url=' + encodeURIComponent(shareParams.link)
    const params = {
      title: shareParams.title,
      desc: shareParams.abstract,
      link: shareParams.link,
      imgUrl: shareParams.image
    }
    if (miniPath) {
      params.miniPath = miniPath
    }
    enableShare(params)
  }
}



// WEBPACK FOOTER //
// ./src/libs/wechat-signature.js